export const formatNumber = (value) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }

    const numValue = parseFloat(value);
    if (!isNaN(numValue) && isFinite(numValue)) {
        return numValue.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

    return value || '';
};

export const handsontableFormatNumber = (value) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }

    const valueString = String(value).trim();

    const numberRegex = /^-?\d+(\.\d+)?$/;

    if (numberRegex.test(valueString)) {

        const parts = valueString.split('.');
        const integerPart = parts[0];
        const decimalPart = parts.length > 1 ? parts[1] : null;

        const formattedIntegerPart = Number(integerPart).toLocaleString(undefined, {
            maximumFractionDigits: 0,
        });

        if (decimalPart !== null) {
            const localeDecimalSeparator = formattedIntegerPart.match(/(\.|,)/);

            const localeSeparatorCheck = (1.1).toLocaleString(undefined);
            const localeDecimalSymbol = localeSeparatorCheck.charAt(1);

            return formattedIntegerPart + localeDecimalSymbol + decimalPart;

        }

        return formattedIntegerPart;

    }

    return value || '';
};

export const titleCase = (str) => {
    if (!str || typeof str !== 'string') return '';
    return str
        .replace(/_/g, ' ')
        .replace(/\w\S*/g, (txt) =>
            txt.charAt(0).toUpperCase() + txt.slice(1)
        );
};

